
import TitleBox from '@/components/CSS/TitleBox'
export default {
    components: {
        TitleBox
    },
    data() {
        return {
            formResult: {
                name: '',
                num: ''
            },
            formRules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                num: [{ required: true, message: '请输入身份证号', trigger: 'blur' }]
            },
            formStatus: 'fill', // fill success fail
            resultIconUrl: {
                fail: 'https://oss.pzds.com/imgv2/auth-fail.png',
                success: 'https://oss.pzds.com/imgv2/auth-success.png'
            },
            resultReason: '',
            path: '',
            pathTetx: '返回',

            // im客服id
            imId: ''
        }
    },
    methods: {
        toPage() {
            if (Boolean(this.path)) {
                // console.log(window.location.origin + this.path)
                window.localStorage.removeItem('realPath')
                this.$store.dispatch('user/UserGetInfo')
                window.location.href = window.location.origin + this.path
            } else {
                this.$router.go(-1)
            }
            // this.$router.path(this.path)
        },
        async doPageTracking() {
            const data = {
                action: {
                    pageEnName: 'certification_info',
                    pageZhName: '实名信息认证'
                }
            }
            const res = await this.$api.pageTracking(data)
            console.log(res)
        },
        // 获取im
        async getAuthService() {
            const res = await this.$api.getAuthService()
            if (!res.success) return this.$message.warning(res.info)
            this.imId = res.data && res.data.username + ''
        },
        onSubmit() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    this.submitForm()
                }
            })
        },
        async submitForm() {
            const data = {
                action: {
                    ...this.formResult
                }
            }
            const res = await this.$api.userAuthVerify(data)
            this.resultReason = res.info
            if (!res.success) return (this.formStatus = 'fail')
            this.formStatus = 'success'
            this.$store.dispatch('user/UserGetInfo')
        },
        getIM() {
            if (!this.imId) return this.$message.warning('暂无客服值班')
            this.$store.dispatch('ry/join', { targetId: this.imId, conversationType: 1 })
        }
    },
    mounted() {
        const path = window.localStorage.getItem('realPath')
        this.path = path
        this.pathTetx = Boolean(path) ? '返回商品详情' : '返回实名认证'
        this.doPageTracking()
        this.getAuthService()
    }
}
